import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { getDoc, doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import useNotification from "../hooks/useNotification";
import EmptyList from "./EmptyList";
import SingleChat from "./SingleChat";
import ShopListCard2 from "./ShopListCard2";

const InviteLists3 = ({
  invitedshoppingListData,
  invitedList,
  setInvitedShoppingListData,
  activeAccordion,
  setActiveAccordion,
  setLoading,
  loading,
}) => {
  const { user } = UserAuth();
  const { addNotification } = useNotification();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [showComments, setShowComments] = useState({});
  const location = useLocation();
  const initialRenderRef = useRef(true);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const urlListId = location.pathname.split("/").pop();
    if (urlListId && urlListId !== "inviteLists") {
      const matchingList = invitedshoppingListData.find(
        (list) => list.listId === urlListId
      );
      if (matchingList) {
        // Bring the matching list to the top
        const reorderedList = [
          matchingList,
          ...invitedshoppingListData.filter(
            (list) => list.listId !== urlListId
          ),
        ];

        setInvitedShoppingListData(reorderedList);
      }
      setActiveAccordion([...activeAccordion, urlListId]);
      setShowComments((prev) => ({
        ...prev,
        [urlListId]: true,
      }));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (initialRenderRef.current && invitedshoppingListData.length > 0) {
      setActiveAccordion([]);
      initialRenderRef.current = false;
    }
    if (!invitedshoppingListData || !invitedList || !user) return;
  }, [invitedshoppingListData, invitedList, user]);

  return (
    <>
      <style jsx>
        {`
          .shoppingList .dropdown-toggle:after {
            display: none;
          }
          .stickyHeader2 {
            position: sticky;
            top: 9rem;
            z-index: 10;
          }
        `}
      </style>
      {!loading && invitedshoppingListData ? (
        invitedshoppingListData?.length > 0 ? (
          <div
            className="row mx-0"
            style={{ marginTop: isSmallScreen ? "" : "4px" }}
          >
            {invitedshoppingListData?.map((list, index) => {
              if (
                activeAccordion === list.listId ||
                activeAccordion.length === 0
              )
                return (
                  <ShopListCard2
                    list={list}
                    shoppingListData={invitedshoppingListData}
                    setShoppingListData={setInvitedShoppingListData}
                    setActiveAccordion={setActiveAccordion}
                    setLoading={setLoading}
                    index={index}
                    key={list?.listId}
                    type={"invitedList"}
                  />
                );
            })}
          </div>
        ) : (
          <div style={{ height: "25rem", maxHeight: "25rem" }}>
            <div
              className={`h-100 d-flex justify-content-center align-items-center flex-column px-5`}
              style={{
                minHeight: "10vh", // Make it fill the full viewport height
                height: "25rem",
                maxHeight: "25rem",
                width: "100%",
                gap: "24px",
              }}
            >
              <svg
                style={{
                  width: "110px",
                }}
                width="141"
                height="141"
                viewBox="0 0 141 141"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="137"
                  height="137"
                  rx="68.5"
                  stroke="#676A79"
                  stroke-width="3"
                />
                <path
                  d="M101 49.3118V97.9365C101 104.143 96.5429 106.754 91.1 103.758L74.2572 94.3839C72.4572 93.3994 69.5428 93.3994 67.7428 94.3839L50.9 103.758C45.4571 106.754 41 104.143 41 97.9365V49.3118C41 41.9924 47 36 54.3285 36H87.6714C95 36 101 41.9924 101 49.3118Z"
                  stroke="#676A79"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div
                style={{
                  whiteSpace: "normal",
                  width: "100%",
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "24px",
                  color: "#676A79",
                  textAlign: "center",
                  // padding: "0 20rem",
                }}
              >
                No Invited List Yet
              </div>
            </div>
          </div>
        )
      ) : null}
      {activeAccordion.length > 0 &&
        invitedshoppingListData?.length > 0 &&
        invitedshoppingListData
          .filter((list) => activeAccordion.includes(list?.listId))
          .map((list) => (
            <SingleChat
              list={list}
              setActiveAccordion={setActiveAccordion}
              isSmallScreen={isSmallScreen}
              shoppingListData={invitedshoppingListData}
              setShoppingListData={setInvitedShoppingListData}
              setLoading={setLoading}
              type={"invitedList"}
            />
          ))}
    </>
  );
};

export default InviteLists3;
